/** @module qt.log
 *  @description 日志行为. 此文档为站内日志打点用，站外打点请使用 qt-web-log，文档参看https://sss.qingting.fm/qt-web-log/docs/index.html
 */
import { invokeIosHandler, invokeAndroidHandler } from '../core';
import { inApp, inIosApp } from '../env';

const isStaging = process.env.NODE_ENV === 'staging';

/** 日志数据, 详见https://sss.qingting.fm/qt-web/qt-jssdk/dist/docs/logFormat.html
 * TODO 是否有具体的类型约束
 */
type EventOptions = Record<string, any>;

/** 此全局变量用于防止同时发送多个log原生出现丢失的情况，沿用之前的写法 */

let logData: Record<string, any> = {};
if (inApp) {
  window.onPageAppear = () => {
    logData = {}; // 新进入webview页面需清理掉日志链，防止页面后退回来时原日志链还存在
  };
}

/**
 * 通用事件打点
 * @example
 * ```
 * qt.log.event({label:'click', data:{
  partner: '91_choujiang',
  pos: { name: 'openVip' }
}})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */

export function event(params: {
  /** 打点标签，可选类型有：'enter'，'click'，'exit'，'vs2', 'popup' */
  label: 'enter' | 'click' | 'exit' | 'vs2' | 'popup';
  data: Record<string, any>;
}) {
  const { label, data } = params;
  if (inApp) {
    if (label === 'exit') {
      logData[label] = data;
    } else {
      logData[label] = logData[label] || [];
      logData[label].push(data);
    }

    if (isStaging) console.log('event logData:', logData);

    if (inIosApp) {
      return invokeIosHandler('pageChainSet', logData, true);
    }
    return invokeAndroidHandler('QTPageChain', 'multiset', JSON.stringify(logData), true);
  }
  console.log('站外打点请使用qt-web-log，详情参看相关文档。');
  return Promise.resolve();
}

/**
 * 页面进入事件打点，可作为pv统计
 * @example
 * ```
 * qt.log.enterEvent({data:{
 partner: '91_choujiang',
 pos: { name: 'openVip' }
 }})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });

 * ```
 */
export function enterEvent(params: EventOptions) {
  const { data } = params;
  return event({
    label: 'enter',
    data,
  });
}

/**
 * 点击事件打点统计
 * @example
 * ```
 * qt.log.clickEvent({data:{
 partner: '91_choujiang',
 pos: { name: 'openVip' }
 }})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 */
export function clickEvent(params: EventOptions) {
  const { data } = params;
  return event({
    label: 'click',
    data,
  });
}

/**
 * 退出事件打点
 * @example
 * ```
 * qt.log.exitEvent({data:{ pos: { name: 'openVip' }}})
  .then(function (res) {
    console.log(res);
  })
  .catch(function (e) {
    console.log(e);
  });
 * ```
 * 
 */
export function exitEvent({ data }: EventOptions) {
  return event({
    label: 'exit',
    data,
  });
}

export const log = {
  event,
  enterEvent,
  clickEvent,
  exitEvent,
};
